export const convertSenasaOrElectronic = (res) => {
  const fetchedDams = res.dams.map((dam) => {
    return {
      id: dam.dam_num,
      consigneeName: dam.consignee_name,
      status: dam.senasa_status,
      updated_at: dam.senasa_uploaded_at,
      volantesNum: dam.volantes_num,
      paidVolantesNum: dam.paid_volantes_num,
      senasaComment: dam.senasa_rejected_comment,
      electronicMandateComment: dam.electronic_mandate_rejected_comment,
    };
  });

  return {
    fetchedDams,
    num_pages: res.num_pages,
    page: res.page,
    count: res.count,
    page_size: res.page_size,
  };
};

export const convertElectronic = (res) => {
  const fetchedDams = res.dams.map((dam) => {
    return {
      id: dam.dam_num,
      consigneeName: dam.consignee_name,
      status: dam.electronic_mandate_status,
      updated_at: dam.electronic_mandate_uploaded_at,
      volantesNum: dam.volantes_num,
      paidVolantesNum: dam.paid_volantes_num,
      senasaComment: dam.senasa_rejected_comment,
      electronicMandateComment: dam.electronic_mandate_rejected_comment,
    };
  });

  return {
    fetchedDams,
    num_pages: res.num_pages,
    page: res.page,
    count: res.count,
    page_size: res.page_size,
  };
};
